import { StyleSheet } from 'react-native';

import { COLOR } from 'utils/colors';
import {
    androidScreenMarginBottom,
    isTabletOrWeb,
    widthPercentageToDP,
} from 'utils/responsiveness';

const styles = StyleSheet.create({
    dialog: {
        backgroundColor: COLOR.BLACK,
        marginBottom: androidScreenMarginBottom,
    },
    button: {
        minWidth: isTabletOrWeb ? 120 : widthPercentageToDP(328),
        width: 'auto',
    },
    actionButtonText: {
        color: COLOR.WHITE,
    },
    cancelButtonText: {
        color: COLOR.background,
    },
});

export default styles;
